import { apiClient, getUserId } from "./authService";

interface PromoData {
  [key: string]: any;
}

export const getAllInvoices = async (): Promise<any> => {
  try {
    const response = await apiClient.get(`/invoices`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllInvoicesByBusiness = async (businessId: string): Promise<any> => {
  try {
    const response = await apiClient.get(`/invoices/by-business/${businessId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllInvoicesByUnit = async (unitId: string): Promise<any> => {
  try {
    const response = await apiClient.get(`/invoices/by-unit/${unitId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllAdminInvoices = async (
  venueId?: string | null
): Promise<any> => {
  try {
    if (!venueId) {
      throw new Error("Venue ID is required to fetch admin invoices");
    }
    const response = await apiClient.get(
      `/invoices/getAdminInvoices/venue/${venueId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllInvoicesForUser = async (client_id: string): Promise<any> => {
  try {
    const userId = client_id;
    const response = await apiClient.get(`/invoices/user/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createInvoice = async (InvoiceData: PromoData): Promise<any> => {
  try {
    const response = await apiClient.post("/invoices", InvoiceData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateInvoice = async (
  id: string,
  InvoiceData: PromoData
): Promise<any> => {
  try {
    const response = await apiClient.put(`/invoices/update/${id}`, InvoiceData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getInvoiceById = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.get(`/invoices/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getInvoiceByIdInClient = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.get(`/invoices/getone/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteInvoice = async (id: string): Promise<any> => {
  try {
    const response = await apiClient.delete(`/invoices/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
